"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let TextTemplates = class TextTemplates extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    onItemSaved(...args) {
        const [data] = args;
        const index = _.indexOf(this.items, { id: data.id });
        if (index > -1) {
            this.items[index] = data;
        }
        else {
            this.items.push(data);
        }
        this.selectedItem = data;
        this.createNewItem = false;
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    items;
    async $$load_items() {
        return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'text-templates' } });
    }
    selectedItem;
    async $$load_selectedItem() {
        return this.items.length ? this.items[0] : null;
    }
    createNewItem;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['items', 'selectedItem', 'createNewItem', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                selectedItem: null,
                createNewItem: false,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_3782_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_3054425420812800_setData_3786_getActionArgs($event) {
        return {
            path: "createNewItem",
            value: true,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_3054425420812800_click(event, scope) {
        return await this.actions.evh_3054425420812800_click.executeFromDOM(this, event, scope);
    }
    async act_3083451129821185_script_3788_getActionArgs_value($event) {
        this.onItemSaved($event.data);
    }
    async act_3083451129821185_script_3788_getActionArgs($event) {
        return {
            value: () => this.act_3083451129821185_script_3788_getActionArgs_value($event),
        };
    }
    async evh_3083451129821185_saved(event, scope) {
        return await this.actions.evh_3083451129821185_saved.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3782 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3782_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3781 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3782,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3781],
        });
        const act_2248226175642056_closeComponent_3784 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3783 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3784,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3783],
        });
        const act_3054425420812800_setData_3786 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3054425420812800_setData_3786_getActionArgs,
            displayName: "addNewTextTemplate",
            events: [],
        });
        const evh_3054425420812800_click_3785 = new core_1.actions.EventHandlerImpl({
            action: act_3054425420812800_setData_3786,
            event: "click",
            displayName: "addNewTextTemplate",
        });
        const evh_3054425420812800_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3054425420812800_click_3785],
        });
        const act_3083451129821185_script_3788 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3083451129821185_script_3788_getActionArgs,
            events: [],
        });
        const evh_3083451129821185_saved_3787 = new core_1.actions.EventHandlerImpl({
            action: act_3083451129821185_script_3788,
            event: "saved",
            displayName: "script",
        });
        const evh_3083451129821185_saved = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3083451129821185_saved_3787],
        });
        const act_1548630417156826_closeComponent_3790 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_3789 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_3790,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_3789],
        });
        return {
            act_7315092382398562_closeModal_3782,
            evh_7315092382398562_close_3781,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3784,
            evh_2248226175642056_close_3783,
            evh_2248226175642056_close,
            act_3054425420812800_setData_3786,
            evh_3054425420812800_click_3785,
            evh_3054425420812800_click,
            act_3083451129821185_script_3788,
            evh_3083451129821185_saved_3787,
            evh_3083451129821185_saved,
            act_1548630417156826_closeComponent_3790,
            evh_1548630417156826_clickPreventStop_3789,
            evh_1548630417156826_clickPreventStop,
            addNewTextTemplate: act_3054425420812800_setData_3786,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], TextTemplates.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TextTemplates.prototype, "onSize", null);
TextTemplates = __decorate([
    (0, vue_property_decorator_1.Component)()
], TextTemplates);
exports.default = TextTemplates;
vue_property_decorator_1.Vue.component("TextTemplates", TextTemplates);
